import {seoMetadata as SeoMetadata} from "@next/utils"
import State from "../../../../models/State"
import {NO_INDEX_NO_FOLLOW_META_ROBOTS} from "../../../../config/constants"

interface SeoMetadata {
    title: string
    keywords: string
    description: string
    robots: string
    canonical?: string
}

export const checkMultipleFacetsFromSameGroup = (state: State, seoMetadata: SeoMetadata) => {
    const newSeoMetadata: SeoMetadata = {...seoMetadata}
    const selectedFacets = Object.keys(state.search?.facets)
        .map(key => (state.search.facets[key].s ? key : null))
        .filter(key => key !== null)
    const set = new Set()

    for (let i = 0; i < selectedFacets.length; ) {
        const groupAndFacet = selectedFacets[i]?.split(":")
        if (groupAndFacet?.length === 2) {
            const groupName = groupAndFacet[0]
            if (groupName !== "gender" && set.has(groupName)) {
                newSeoMetadata.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
                break
            } else {
                set.add(groupName)
            }
        }
        i += 1
    }

    if (set.size >= state.seoFilters.filterDepthCount) {
        newSeoMetadata.robots = NO_INDEX_NO_FOLLOW_META_ROBOTS
    }
    return newSeoMetadata
}
